import React from "react";
import ReactDOM from "react-dom/client";
import { ErrorBoundary } from "react-error-boundary";
import { RouterProvider } from "react-router/dom";
import "@fontsource/ibm-plex-sans-thai-looped/thai-400.css";
import "@fontsource/ibm-plex-sans-thai-looped/latin-400.css";
import "@fontsource/ibm-plex-sans-thai-looped/thai-500.css";
import "@fontsource/ibm-plex-sans-thai-looped/latin-500.css";
import "@fontsource/ibm-plex-sans-thai-looped/thai-600.css";
import "@fontsource/ibm-plex-sans-thai-looped/latin-600.css";
import "@fontsource/ibm-plex-sans-thai-looped/thai-700.css";
import "@fontsource/ibm-plex-sans-thai-looped/latin-700.css";
import "@fontsource/bai-jamjuree/thai-600.css";
import "@fontsource/bai-jamjuree/latin-600.css";
import "@fontsource/bai-jamjuree/thai-700.css";
import "@fontsource/bai-jamjuree/latin-700.css";
import { AppProviders } from "./app/providers/app-providers";
import { router } from "./app/router/router";
import { GlobalErrorState } from "./components/feedback/states";
import "./styles/global.css";

const root = document.getElementById("root");
if (!root) throw new Error("ConLit root element was not found");

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <ErrorBoundary FallbackComponent={GlobalErrorState}>
      <AppProviders>
        <RouterProvider router={router} />
      </AppProviders>
    </ErrorBoundary>
  </React.StrictMode>,
);
